export default "__VITE_ASSET__36324dfa__"